import { render, staticRenderFns } from "./FormAnnualTax.vue?vue&type=template&id=61af1dfc&scoped=true"
import script from "./FormAnnualTax.vue?vue&type=script&lang=js"
export * from "./FormAnnualTax.vue?vue&type=script&lang=js"
import style0 from "./FormAnnualTax.vue?vue&type=style&index=0&id=61af1dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af1dfc",
  null
  
)

export default component.exports